// The signed-in person's permissions, read once from /api/v1/auth/me and shared. Columns and exports that need a
// permission (cost.view …) stay hidden until the permissions are known — never shown first and taken away later.
// The API remains the authority: it does not send cost figures to a role without cost.view in the first place.
import React from 'react';
import { api } from '../api';

let cache: Promise<Set<string>> | null = null;
let known: Set<string> | null = null;
const load = () => (cache ??= api<{ permissions?: string[] }>('/api/v1/auth/me').then(m => (known = new Set(m.permissions ?? []))).catch(() => (known = new Set<string>())));

/** The permission set, or null while it loads. */
export function usePermissions(): Set<string> | null {
  const [p, setP] = React.useState<Set<string> | null>(known);
  React.useEffect(() => { if (known) { setP(known); return; } let on = true; load().then(s => on && setP(s)); return () => { on = false; }; }, []);
  return p;
}
/** True only when the permission is known to be held. */
export const allowed = (perms: Set<string> | null, need?: string) => !need || !!perms?.has(need);
/** For tests and sign-out. */
export const resetPermissions = (p?: string[]) => { known = p ? new Set(p) : null; cache = p ? Promise.resolve(known!) : null; };
